// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    deleteRegistration,
    getRegistration
} from '../../../product/shared/repositories';
import actions from '../../actions-list';
import {getDefaultState as getRegistrationDefaultState} from '@deere/cps-it.warranty-model-factory/lib/registration';
import {readProductDetails} from './product-details';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateRegistrationModals} from './registration-modals';

export const deleteProductRegistration = id =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await deleteRegistration(id);

            updateRegistrationModals('confirmDeleteModal', false)(dispatch);
            successAlertBar(translate('DELETE_REGISTRATION_SUCCESS'));
            dispatch(routerActions.push('/products/registrations'));

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const readRegistration = id =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const registration = await getRegistration(id);

            if (registration.product.pin !== '') {

                readProductDetails(registration.product.pin, false, [], registration.statusIndicator.key, registration.customer)(dispatch);

            }

            dispatch({
                data: registration,
                type: actions.UPDATE_PRODUCT_REGISTRATION
            });
            dispatch({
                data: registration.deliveryDate,
                type: actions.UPDATE_REGISTRATION_PREVIOUS_DELIVERY_DATE
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetRegistration = () => ({
    data: getRegistrationDefaultState(),
    type: actions.RESET_PRODUCT_REGISTRATION
});

export const updateRegistration = (property, value) =>

    dispatch =>

        dispatch({
            property,
            type: actions.UPDATE_PRODUCT_REGISTRATION_REGISTRATION,
            value
        });

export const updateOtherUseAmount = (property, value) => ({
    property,
    type: actions.UPDATE_PRODUCT_REGISTRATION_REGISTRATION_OTHER_USE_AMOUNT,
    value
});

export const updateUseAmount = (property, value) =>

    dispatch =>

        dispatch({
            property,
            type: actions.UPDATE_PRODUCT_REGISTRATION_REGISTRATION_USE_AMOUNT,
            value
        });

export const updateDealerLocation = location => ({
    location,
    type: actions.UPDATE_PRODUCT_REGISTRATION_REGISTRATION_LOCATION
});

export const updateRegistrationPin = pin =>

    dispatch =>

        dispatch({
            pin,
            type: actions.UPDATE_PRODUCT_REGISTRATION_REGISTRATION_PIN
        });



// WEBPACK FOOTER //
// ./src/product/product-registration/action-creators/registration.js